import { FaSortDown, FaSortUp } from 'react-icons/fa';

const ReportsTableHeader = ({ sortConfig, handleSort }) => {
  const renderSortIcon = (columnKey) => {
    if (sortConfig.key !== columnKey || !sortConfig.direction) {
      return null;
    }
    if (sortConfig.direction === 'asc') {
      return <FaSortUp className="sort-icon active" />;
    }
    if (sortConfig.direction === 'desc') {
      return <FaSortDown className="sort-icon active" />;
    }
    return null;
  };

  return (
    <div className="reports-table-header">
      <div
        className="header-cell sortable"
        onClick={() => handleSort('code')}
        title="OS"
      >
        <span>OS</span>
        {renderSortIcon('code')}
      </div>
      <div
        className="header-cell sortable"
        onClick={() => handleSort('vehicle')}
        title="Veículo"
      >
        <span>Veículo</span>
        {renderSortIcon('vehicle')}
      </div>
      <div
        className="header-cell sortable"
        onClick={() => handleSort('mo_lataria')}
        title="Funilaria/Pintura"
      >
        <span>Funilaria/Pintura</span>
        {renderSortIcon('mo_lataria')}
      </div>
      <div
        className="header-cell sortable"
        onClick={() => handleSort('qtd_horas_lataria')}
        title="Qtd Horas"
      >
        <span>Qtd Horas</span>
        {renderSortIcon('qtd_horas_lataria')}
      </div>
      <div
        className="header-cell sortable"
        onClick={() => handleSort('qtd_pecas_pintadas')}
        title="Peças Pintadas"
      >
        <span>Peças Pintadas</span>
        {renderSortIcon('qtd_pecas_pintadas')}
      </div>
      <div
        className="header-cell sortable"
        onClick={() => handleSort('mo_estetica')}
        title="Serviços"
      >
        <span>Serviços</span>
        {renderSortIcon('mo_estetica')}
      </div>
      <div
        className="header-cell sortable"
        onClick={() => handleSort('qtd_horas_estetica')}
        title="Qtd Horas"
      >
        <span>Qtd Horas</span>
        {renderSortIcon('qtd_horas_estetica')}
      </div>
      <div
        className="header-cell sortable"
        onClick={() => handleSort('valor_pecas')}
        title="Venda Peças"
      >
        <span>Venda Peças</span>
        {renderSortIcon('valor_pecas')}
      </div>
      <div
        className="header-cell sortable"
        onClick={() => handleSort('custo_pecas')}
        title="Custo Peças"
      >
        <span>Custo Peças</span>
        {renderSortIcon('custo_pecas')}
      </div>
      <div
        className="header-cell sortable"
        onClick={() => handleSort('lucro_pecas')}
        title="Lucro Peças"
      >
        <span>Lucro Peças</span>
        {renderSortIcon('lucro_pecas')}
      </div>
      <div
        className="header-cell sortable"
        onClick={() => handleSort('total_os')}
        title="Total OS"
      >
        <span>Total OS</span>
        {renderSortIcon('total_os')}
      </div>
      <div
        className="header-cell sortable"
        onClick={() => handleSort('status')}
        title="Status"
      >
        <span>Status</span>
        {renderSortIcon('status')}
      </div>
      <div
        className="header-cell header-cell-last sortable"
        onClick={() => handleSort('previsao_entrega')}
        title="Previsão Entrega"
      >
        <span>Previsão/Fechamento</span>
        {renderSortIcon('previsao_entrega')}
      </div>
    </div>
  );
};

export default ReportsTableHeader;
